const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">{children}</main>
      <footer className="bg-midnight text-white text-center py-4">
        <div className="mx-auto w-7/8 border-t-1 border-gray-600 mb-4 rounded-full" />
        <div className="flex justify-center md:justify-between items-center w-4/5 mx-auto">
          <p>&copy; Colorizon Ventures. All rights reserved.</p>
          <div className="hidden md:flex">
            <nav>
              <ul className="flex gap-6 justify-center items-center">
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#contact">Contact Us</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
